import { render, staticRenderFns } from "./ContactUsEntity.vue?vue&type=template&id=b6748d0e&"
import script from "./ContactUsEntity.vue?vue&type=script&lang=js&"
export * from "./ContactUsEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports